export enum PrErrorCodeEnum {
  // File API errors
  FILE_API_CONNECTION_FAILED = 1001,
  FILE_API_UPLOAD_FAILED = 1002,
  FILE_API_BAD_REQUEST = 1003,
  FILE_API_TIMEOUT = 1004,
  FILE_API_AUTHENTICATION_FAILED = 1005,
  FILE_API_NOT_FOUND = 1006,
  FILE_API_PERMISSION_DENIED = 1007,
  FILE_API_CONFILCT = 1008,

  // MyDocma API errors
  MYDOCMA_API_AUTHORIZATION_FAILED = 2001,
  URL_SHORTENER_API_ERROR = 2002,

  // PR processing errors
  PR_DOC_NOT_FOUND = 3001,
  PR_FILE_NOT_FOUND = 3002,
  PR_DELETE_FAILED = 3003,
  PR_CONFIG_FETCH_FAILED = 3004,
  PR_FILE_IN_USE_WITH_OTHER_DOCUMENTS = 3005,
  PR_ARCHIVE_PREVIEW_GENERATION_FAILED = 3006,
  PR_OFFICE_PREVIEW_GENERATION_FAILED = 3007,
  PR_UNSUPPORTED_PREVIEW_FILE_TYPE = 3008,
  PR_FILE_TYPE_DETECTION_FAILED = 3009,
  PR_FILE_REF_NOT_FOUND = 3010,
  PR_NO_CHANGES_DETECTED = 3011,
  PR_DOC_HISTORY_NOT_FOUND = 3012,
  PR_DOWNLOAD_SIZE_EXCEEDED = 3013,
  PR_SHARED_DOC_NOT_FOUND = 3014,
  PR_SHARED_FILE_FORBIDDEN = 3015,
  PR_SHARED_DOC_FORBIDDEN = 3016,
  PR_SHARED_CREATION_FAILED = 3017,
  PR_EMAIL_PREVIEW_GENERATION_FAILED = 3018,
  PR_DOC_UPDATE_FAILED = 3019,

  // Request validation errors
  REQUEST_INVALID_JSON = 4001,
  REQUEST_VALIDATION_FAILED = 4002,
  REQUEST_MISSING_FIELDS = 4003,
  REQUEST_INVALID_IDS = 4004,
  REQUEST_FILE_SIZE_EXCEEDED = 4005,
  REQUEST_MISSING_FILE_OR_FILE_ID = 4006,
  REQUEST_TOO_MANY_ITEMS = 4007,
  REQUEST_CONFLICTING_FILE_INPUT = 4008,
  REQUEST_INVALID_GROUPING_FIELD = 4009,
  REQUEST_INVALID_SORTING_FIELD = 4010,
  REQUEST_INVALID_FILTER_FIELD = 4011,
  REQUEST_INVALID_FILTER_OPERATOR = 4012,
  REQUEST_INVALID_FILETYPE_ARRAY = 4013,
  REQUEST_INVALID_FILETYPE_VALUE = 4014,
  REQUEST_TIME_INVALID = 4015,

  // Folders errors
  FOLDER_NOT_FOUND = 5001,
  FOLDER_INVALID_OPERATION = 5002,
  FOLDER_UPDATE_FAILED = 5003,
  FOLDER_DELETE_FAILED = 5004
}

export const PR_ERROR_MESSAGES: Record<string, string> = {
  [PrErrorCodeEnum.PR_DELETE_FAILED]: 'Invalid document ID(s) provided.',
};
